import * as React from "react";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import CoughAnalysisSetUtilities from "../../Shared/CoughAnalysisSetUtilities";
import { AnalysisSetReferenceTag } from "../../Shared/AnalysisSetReferenceTag";
import { AnalysisSetLink, CoughAnalysisSet } from "webportalclient";

interface CoughAnalysisSetTypeDisplayProps {
    analysisSet: CoughAnalysisSet;
}

const getTooltip = (sourceAnalysisSetLink: AnalysisSetLink) => {

    return (sourceAnalysisSetLink ?
        <Tooltip id="tooltip" style={{ zIndex: 2500 }}>
        <AnalysisSetReferenceTag typeName={sourceAnalysisSetLink.linkTypeName} coughSetTypeName={sourceAnalysisSetLink.targetCoughType} created={sourceAnalysisSetLink.targetCreated} status={sourceAnalysisSetLink.targetStatusName} />
            </Tooltip> : null);
}

const getInfo = (analysisSet: CoughAnalysisSet) => {
    const sourceAnalysisSetLink = CoughAnalysisSetUtilities.GetSourcedFromLink(analysisSet);

    const createdFromAnalysisSetLink = CoughAnalysisSetUtilities.GetCreatedFromLink(analysisSet);

    if (sourceAnalysisSetLink) {
        return (<OverlayTrigger placement="top" overlay={getTooltip(sourceAnalysisSetLink)}><span className="label label-info">Linked</span></OverlayTrigger>);
    }

    if (createdFromAnalysisSetLink) {
        return (<OverlayTrigger placement="top" overlay={getTooltip(createdFromAnalysisSetLink)}><span className="fas fa-info-circle"></span></OverlayTrigger>);
    }

    return null;
}

const CoughAnalysisSetTypeDisplay = ({ analysisSet }: CoughAnalysisSetTypeDisplayProps): JSX.Element => {
    return (<>
        {analysisSet.typeName} {getInfo(analysisSet)}
    </>)

};

export default CoughAnalysisSetTypeDisplay;
